import { useQueryClient } from "@tanstack/react-query";
import { diaryKeys } from "./diaryKeys";

export function useDiaryInvalidation() {
	const queryClient = useQueryClient();

	return {
		invalidateAll: () => {
			queryClient.invalidateQueries({ queryKey: diaryKeys.all });
		},
		invalidateById: (diaryId: string) => {
			queryClient.invalidateQueries({ queryKey: diaryKeys.detail(diaryId) });
		},
		invalidateByPatient: (patientId: string) => {
			queryClient.invalidateQueries({
				queryKey: diaryKeys.byPatient(patientId),
			});
		},
		invalidateBySettings: (filters: Record<string, unknown> = {}) => {
			queryClient.invalidateQueries({
				queryKey: diaryKeys.bySettings(filters),
			});
		},
		invalidateTabs: (filters: Record<string, unknown> = {}) => {
			queryClient.invalidateQueries({ queryKey: diaryKeys.tabs(filters) });
		},
	};
}
